<template>
  <div>
    <v-row class="pl-6 ma-0 condition-wrap">
      <v-col
        cols="12"
        class="pa-0 pt-1 d-flex justify-space-between"
        @click="toSelectDate"
      >
        <span class="label">연장근무 신청일</span>
        <span class="date">{{ GET_WORK_YMD }}</span>
      </v-col>
    </v-row>
    <v-row class="pl-6 ma-0 bt-line condition-wrap">
      <!-- 시간 -->
      <v-col cols="12" class="pa-0 pb-1 mt-3 d-flex justify-space-between">
        <span class="label">출근시간</span>
        <span class="date">{{ GET_REQ_S_HM }}</span>
      </v-col>
      <v-col
        cols="12"
        class="pa-0 pt-4 bt-line mt-3 d-flex justify-space-between"
      >
        <span class="label">퇴근시간</span>
        <span class="date">{{ GET_REQ_E_HM }}</span>
      </v-col>
    </v-row>
    <v-row class="pl-6 ma-0 bt-line condition-wrap">
      <!-- 시간 -->
      <v-col cols="12" class="pa-0 pb-1 mt-3 d-flex justify-space-between">
        <span class="label">연장근무시간</span>
        <span class="date"
          >{{ GET_REQUEST_HOUR }}시간 ( 휴게 : {{ GET_REST_HOUR }}시간 제외
          )</span
        >
      </v-col>
      <v-col
        v-if="GET_ALTER_GNT_NM !== ''"
        cols="12"
        class="pa-0 pt-5 pb-1 bt-line mt-3 d-flex justify-space-between"
      >
        <span class="label">근무종류</span>
        <span class="date">{{ GET_ALTER_GNT_NM }}</span>
      </v-col>
      <v-col
        cols="12"
        class="pa-0 pt-4 bt-line mt-3 borderLine-outer"
        v-if="GET_OTWORK_APPL_GUBUN === 'A'"
      >
        <div class="d-flex justify-space-between">
          <span class="borderLine-title">출퇴근변경신청 여부</span>
          <span class="point-blue">{{
            GET_IN_OUT_YN === 'Y' ? '신청함' : '신청 안 함'
          }}</span>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import routerNames from '@/const/routerConstants';
import applCdMixin from '@/mixins/applCdMixin.js';
import extraOptionsMixin from '@/mixins/extraOptionsMixin.js';

import { mapGetters } from 'vuex';

export default {
  mixins: [applCdMixin, extraOptionsMixin],
  data: () => ({
    chips: [],
  }),
  computed: {
    ...mapGetters('ELA', [
      'GET_WORK_YMD',
      'GET_ALTER_YMD',
      'GET_ALTER_GNT_NM',
      'GET_REQUEST_HOUR',
      'GET_REST_HOUR',
      'GET_IN_OUT_YN',
      'GET_REQ_S_HM',
      'GET_REQ_E_HM',
      'GET_OTWORK_APPL_GUBUN',
    ]),
  },
  methods: {},
};
</script>

<style></style>
